import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  ConfirmFormModal,
  DrawStage,
  // ExpandCollapse,
  SnackBarMessage
} from "@toorak/tc-common-fe-sdk";
import { useDrawsStyles } from "./Draws.styles";
import {
  getAvailableLoanIds,
  getDrawDetailsbyLoanId,
  // getDrawDetailsByDrawId,
  deleteDrawById,
  // updateTableSortOptions,
  // updateTableFilters,
  // updateTableSearchConfig,
  // updateGlobalSearchValue,
  getFieldHistory,
  getProvisionHistory,
  getDrawHistory
} from "../../stores/drawRequest/drawRequest.action";
import { RootState } from "../../stores/rootReducer";

// import { BankDetailsWrapper } from "./BankDetailsWrapper";
import {
  hideLoader,
  showLoader
} from "../../stores/loaderAndException/loaderAndException.action";
import { isOrigUser } from "../../utils/AccessManagement";
import { DrawDetailsRecapInfo } from "./DrawDetailsRecapInfo";
import { DrawRequestStore } from "../../stores/drawRequest/drawRequest.interface";
import { DrawTabs } from "./DrawDataLeftPanel/DrawTabs";
import { isAMTView } from "../AssetManagement.utils";

import { snackBarDetails } from "./Constant";
import { DrawDetailsHeader } from "./DrawHeader/DrawDetailsHeader";
import { isBulkDrawViewEnabled } from "./DrawDetailsConstants";
import { DrawRightPanelWrapper } from "./DrawDataRightPanel/DrawRightPanelWrapper";
import {
  clearDrawRedux,
  setSelectedLoans,
  updateDrawExcelData,
  updateSearchValue,
  updateTableFilters,
  updateTableSearchOptions,
  updateTableSortOptions
} from "../../stores/drawRequest/drawRequest.reducer";

export const DrawDetails = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useDrawsStyles();

  // const [availableLoanIds, setAvailableLoanIds] = useState<any>([]);
  // const [isMinimizedLoanDetail, setIsMinimizedLoanDetail] = useState<boolean>(
  //   false
  // );
  // const [isMinimizedLoanEconomics, setIsMinimizedLoanEconomics] = useState<
  // boolean > false;
  // const [isMinimizedProvision, setIsMinimizedProvision] = useState<boolean>(
  //   false
  // );
  const [isSubmitClicked, setIsSubmitClicked] = useState<boolean>(false);
  const [selectedLoanId, setSelectedLoanId] = useState<string | null>(null);
  const [selectedProperty, setSelectedProperty] = useState<string[]>([]);
  const [drawObj, setDrawObj] = useState<any>({});
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [confirmationMgs, setConfirmationMgs] = useState<any>({
    text: "",
    header: ""
  });
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [snackBarMsg, setSnackBarMsg] = useState<any>({
    messageType: "",
    message: ""
  });
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [provisionHistory, setProvisionHistory] = useState<any>([]);
  const lastLoanDetailsRequestRef = useRef<{ drawId: string; toorakLoanId: string } | null>(null);
  const prevDrawIdRef = useRef<string | null>(null);
  const lastSyncDrawKeyRef = useRef<string>("");
  const didHandleLoanIdChangeRef = useRef<string>("");
  const didRequestLoanIdsRef = useRef(false);
  const {
    draft,
    drawSubmitted,
    initialApproval,
    finalApproval,
    inProgress,
    WireUnsuccessful,
    DrawInQueue,
    hold
  } = DrawStage;

  const { drawId } = useParams<any>() as any;
  const isOrig = isOrigUser();

  const {
    loanIds,
    drawDetails,
    tableSortConfig,
    tableSearchConfig,
    tableFilterConfig
  } = useSelector<RootState, DrawRequestStore>(
    (state) => state.drawRequestStore,
    shallowEqual
  );
  const isInDraftStage = drawDetails?.stage === draft;

  useEffect(() => {
    if (loanIds?.length) {
      didRequestLoanIdsRef.current = false;
      return;
    }
    if (didRequestLoanIdsRef.current) return;
    didRequestLoanIdsRef.current = true;
    dispatch(getAvailableLoanIds(isOrig));
  }, [isOrig, dispatch, loanIds?.length]);

  // Disabled: was triggering re-render cascade. Table filter is cleared when leaving draw details or via table UI.
  // useEffect(() => {
  //   if (!loanIds?.length) {
  //     didClearFilterForLoanIdsRef.current = false;
  //     return;
  //   }
  //   if (didClearFilterForLoanIdsRef.current) return;
  //   didClearFilterForLoanIdsRef.current = true;
  //   batch(() => {
  //     clearFilter();
  //     dispatch(setSelectedLoans([]));
  //   });
  // }, [loanIds?.length]);

  const drawAmountDetailsKey = JSON.stringify(drawDetails?.drawAmountDetails ?? {});
  useEffect(() => {
    if (!drawDetails) return;
    // Skip syncing when we only have initial/empty draw (no drawId from API yet) to avoid setState on every store tick
    const hasRealData = drawDetails?.drawId != null || (drawDetails?.primaryLoanId != null && drawDetails?.primaryLoanId !== "");
    if (!hasRealData) return;
    const syncKey = `${drawDetails?.primaryLoanId}|${drawDetails?.drawId}|${drawDetails?.stage}|${drawDetails?.propertyDetails?.length ?? ""}|${drawAmountDetailsKey}`;
    if (lastSyncDrawKeyRef.current === syncKey) return;
    lastSyncDrawKeyRef.current = syncKey;
    setDrawObj(drawDetails);
    setSelectedLoanId(drawDetails?.primaryLoanId ?? null);
    if (drawDetails.propertyDetails?.length) {
      setSelectedProperty(drawDetails.propertyDetails);
    } else {
      setSelectedProperty([]);
    }
    // eslint-disable-next-line
  }, [
    drawDetails?.primaryLoanId,
    drawDetails?.drawId,
    drawDetails?.stage,
    drawDetails?.propertyDetails?.length,
    drawAmountDetailsKey
  ]);

  // Fetch provision history only when the loan (toorakLoanId) changes, not on every draw update/autosave.
  useEffect(() => {
    if (isOrig || !drawDetails?.toorakLoanId) return;
    dispatch(getProvisionHistory(drawDetails.toorakLoanId, provisionHistorycallBack));
    // eslint-disable-next-line
  }, [drawDetails.toorakLoanId]);

  const provisionHistorycallBack = (data: any) => {
    setProvisionHistory(data);
  };

  const updateIsSubmitClicked = (val: boolean) => {
    setIsSubmitClicked(val);
  };

  useEffect(() => {
    const bulkDraw = isBulkDrawViewEnabled();
    // Call handleLoanIdChange at most once per (drawId, primaryLoanId) when we have no property details,
    // to avoid re-render loop when API never returns propertyDetails.
    if (
      !bulkDraw &&
      drawDetails?.primaryLoanId &&
      !drawDetails.propertyDetails?.length &&
      isInDraftStage
    ) {
      const handleKey = `${drawId}|${drawDetails.primaryLoanId}`;
      if (didHandleLoanIdChangeRef.current !== handleKey) {
        didHandleLoanIdChangeRef.current = handleKey;
        handleLoanIdChange(drawDetails.primaryLoanId);
      }
    } else if (!drawDetails?.primaryLoanId || drawDetails?.propertyDetails?.length) {
      didHandleLoanIdChangeRef.current = "";
    }

    // When landing on a draw (including Excel-created draws), always attempt to fetch
    // loan details once we have a draft draw and a resolvable Toorak loan id.
    // If drawDetails.toorakLoanId is missing (Excel path), derive from loanIds or Excel row.
    const matchedLoanFromList = loanIds?.find((loan: any) => {
      const primaryFromList =
        loan.primaryLoanId || loan.primary_loan_id || loan.primaryloanid;
      return (
        primaryFromList &&
        drawDetails?.primaryLoanId &&
        primaryFromList.toString() === drawDetails.primaryLoanId.toString()
      );
    });
    let excelRowForDraw: any = null;
    if (bulkDraw && drawId) {
      try {
        const stored = sessionStorage.getItem("drawExcelUpload");
        if (stored) {
          const rows = JSON.parse(stored);
          excelRowForDraw = rows?.find((r: any) => String(r?.drawId) === String(drawId)) ?? null;
        }
      } catch (_) {}
    }

    const effectiveToorakLoanId =
      drawDetails?.toorakLoanId ||
      matchedLoanFromList?.toorakLoanId ||
      matchedLoanFromList?.toorak_loan_id ||
      matchedLoanFromList?.toorakloanid ||
      excelRowForDraw?.toorakLoanId ||
      excelRowForDraw?.toorak_loan_id ||
      excelRowForDraw?.toorakloanid ||
      null;

    if (!drawId || !drawDetails?.primaryLoanId || !effectiveToorakLoanId) return;

    // Only run when drawDetails are for this draw (from getDrawDetailsByDrawId), so Excel/first-load bank is in state.
    const drawDetailsMatchUrl = !drawDetails?.drawId || String(drawDetails.drawId) === String(drawId);
    if (!drawDetailsMatchUrl) return;

    if (prevDrawIdRef.current !== drawId) {
      prevDrawIdRef.current = drawId;
      lastLoanDetailsRequestRef.current = null;
    }
    // Avoid duplicate calls: only fetch loan-details once per (drawId, toorakLoanId).
    const requestKey = `${drawId}|${effectiveToorakLoanId}`;
    const lastKey = lastLoanDetailsRequestRef.current
      ? `${lastLoanDetailsRequestRef.current.drawId}|${lastLoanDetailsRequestRef.current.toorakLoanId}`
      : null;
    if (lastKey === requestKey) return;
    lastLoanDetailsRequestRef.current = { drawId, toorakLoanId: effectiveToorakLoanId };

    if (isInDraftStage) {
      dispatch(
        getDrawDetailsbyLoanId(
          isOrig,
          effectiveToorakLoanId,
          drawId,
          setSnackBarMsg,
          setOpenSnackBar,
          bulkDraw
        )
      );
    }
    // eslint-disable-next-line
  }, [drawId, drawDetails?.primaryLoanId, drawDetails?.toorakLoanId, drawDetails?.drawId, loanIds?.length]);

  useEffect(() => {
    const toorakLoanId: string = drawDetails?.toorakLoanId as string;
    if (!isAMTView() || !toorakLoanId) return;
    dispatch(getDrawHistory(toorakLoanId));
    // eslint-disable-next-line
  }, [drawDetails.primaryLoanId]);

  // useEffect(() => {
  //   if (!drawId) return;
  //   dispatch(getDrawDetailsByDrawId(drawId, isOrig));
  // }, [drawId, dispatch, isOrig]);

  useEffect(() => {
    if (!isInDraftStage && !isBulkDrawViewEnabled()) {
      dispatch(getFieldHistory(drawId, isOrig));
    }
    // eslint-disable-next-line
  }, [isInDraftStage, dispatch, drawId, isOrig]);

  const clearFilter = () => {
    tableFilterConfig !== undefined && dispatch(updateTableFilters(undefined));
    tableSortConfig !== undefined &&
      dispatch(updateTableSortOptions(undefined));
    tableSearchConfig !== undefined &&
      dispatch(updateTableSearchOptions(undefined));

    dispatch(updateSearchValue(""));
  };

  const updateIsEditing = (val: boolean) => {
    if (val) {
      dispatch(
        getDrawDetailsbyLoanId(
          isOrig,
          drawDetails?.toorakLoanId,
          drawId,
          setSnackBarMsg,
          setOpenSnackBar,
          false,
          undefined,
          undefined,
          true
        )
      );
    }

    setIsEditing(val);
  };

  const isAmounteditable = () =>
    isInDraftStage ||
    (isOrig
      ? isEditing && [drawSubmitted, DrawInQueue, hold].includes(drawObj.stage)
      : isEditing &&
        [
          drawSubmitted,
          inProgress,
          initialApproval,
          DrawInQueue,
          WireUnsuccessful,
          finalApproval
        ].includes(drawObj.stage));

  const goBackToLoanListPage = () => {
    if (isOrig) {
      navigate("/loans/list?tab=8");
    } else {
      navigate("/asset/home?tab=0");
    }
    dispatch(clearDrawRedux());
  };

  const handleLoanIdChange = (newVal: string | null) => {
    setSelectedLoanId(newVal);
    if (newVal) {
      dispatch(
        getDrawDetailsbyLoanId(
          isOrig,
          drawDetails?.toorakLoanId ?? newVal,
          drawId,
          setSnackBarMsg,
          setOpenSnackBar,
          true,
          drawDetails.drawAmountDetails,
          drawObj
        )
      );
    }
  };

  const handleConfirmation = () => {
    setOpenConfirmBox(false);
  };

  const deleteDraw = () => {
    dispatch(showLoader());
    deleteDrawById(drawId).then((res: any) => {
      dispatch(hideLoader());
      dispatch(clearDrawRedux());
    });
    setOpenConfirmBox(false);
    setSnackBarMsg({
      messageType: "success",
      message: "Draw is successfully deleted."
    });
    setOpenSnackBar(true);
    if (isBulkDrawViewEnabled() && isOrig) {
      const excelUploadDataInSession =
        sessionStorage.getItem("drawExcelUpload");
      if (excelUploadDataInSession) {
        const excelUploadData = JSON.parse(excelUploadDataInSession);
        const drawIndex = excelUploadData.findIndex(
          (item?: any) => item.drawId.toString() === drawId
        );
        excelUploadData.splice(drawIndex, 1);
        if (excelUploadData.length) {
          excelUploadData[0].selected = true;
          dispatch(updateDrawExcelData(excelUploadData));
          sessionStorage.setItem(
            "drawExcelUpload",
            JSON.stringify(excelUploadData)
          );
          navigate(`/drawDetails/${excelUploadData[0].drawId}`);
        } else {
          setTimeout(() => {
            goBackToLoanListPage();
          }, 1500);
        }
      }
    } else {
      setTimeout(() => {
        goBackToLoanListPage();
      }, 1500);
    }
  };

  const showDeleteDrawWarning = () => {
    setConfirmationMgs({
      text: `Are you sure you want to delete this Draw?`,
      header: `Delete Draw`
    });
    setOpenConfirmBox(true);
  };

  const showErrorMsg = (field: any) => {
    const returnJSX = (
      <div className={classes.errorMgs}>This is a mandatory field.</div>
    );
    const returnNetFundsJSX = (
      <div className={classes.errorMgs}>
        Net Funds To Borrower must be positive.
      </div>
    );
    switch (field) {
      case "selectedLoanId": {
        if (selectedLoanId === "") return returnJSX;
        return null;
      }
      case "selectedProperty": {
        if (!selectedProperty.length) return returnJSX;
        return null;
      }
      case "drawAmount": {
        if (!displayDraw?.drawAmountDetails?.drawAmount) return returnJSX;
        return null;
      }
      case "wireFee": {
        if (!displayDraw?.drawAmountDetails?.wireFee) return returnJSX;
        return null;
      }
      case "costOfInspection": {
        if (
          displayDraw?.drawAmountDetails?.costOfInspection === null ||
          displayDraw?.drawAmountDetails?.costOfInspection === undefined ||
          displayDraw?.drawAmountDetails?.costOfInspection === ""
        )
          return returnJSX;
        return null;
      }
      case "titleServiceFee": {
        if (
          displayDraw?.drawAmountDetails?.titleServiceFee === null ||
          displayDraw?.drawAmountDetails?.titleServiceFee === undefined ||
          displayDraw?.drawAmountDetails?.titleServiceFee === ""
        )
          return returnJSX;
        return null;
      }
      case "netFundsToBorrower": {
        if (displayDraw?.drawAmountDetails?.netFundsToBorrower <= 0)
          return returnNetFundsJSX;
        return null;
      }
    }
  };

  const rightPanelWidth = isInDraftStage ? 12 : 8;

  // Prefer Redux drawDetails when it's for the current draw so UI shows correct values (e.g. Excel-merged amount) without waiting for sync effect
  const displayDraw =
    drawDetails?.drawId != null && String(drawDetails.drawId) === String(drawId)
      ? drawDetails
      : drawObj;

  return (
    <>
      <Grid item container xs={12} sm={12} md={12} xl={12}>
        <DrawDetailsHeader
          drawId={drawId}
          isOrig={isOrig}
          showDeleteDrawWarning={showDeleteDrawWarning}
          updateIsSubmitClicked={updateIsSubmitClicked}
          goBackToLoanListPage={goBackToLoanListPage}
          updateIsEditing={updateIsEditing}
          isEditing={isEditing}
          toorakLoanId={drawDetails.toorakLoanId}
        />

        {!isInDraftStage && (
          <DrawDetailsRecapInfo
            drawStage={displayDraw.stage}
            netFundsToBorrower={displayDraw.drawAmountDetails?.netFundsToBorrower}
            classes={classes}
            drawId={drawId}
          />
        )}
      </Grid>

      <Grid
        item
        container
        xs={rightPanelWidth}
        data-testid="draw-view-wrapper-Container"
        className={classes.insightContainer}
      >
        <DrawTabs
          isSubmitClicked={isSubmitClicked}
          selectedLoanId={selectedLoanId}
          drawObj={displayDraw}
          isAmounteditable={isAmounteditable}
          isBulkDraw={props.isBulkDraw}
          showErrorMsg={showErrorMsg}
          isEditing={isEditing}
          provisionHistory={provisionHistory}
          setSnackBarMsg={setSnackBarMsg}
          setOpenSnackBar={setOpenSnackBar}
        />
      </Grid>
      {!isInDraftStage && (
        <Grid
          item
          container
          xs={4}
          data-testid="draw-view-wrapper-Container"
          // className={classes.}
        >
          <>
            <Grid item container xs={1} />

            <Grid
              item
              container
              xs={11}
              className={classes.insightContainer}
              style={{ height: 1200 }}
            >
              <DrawRightPanelWrapper drawId={drawId} />
            </Grid>
          </>
        </Grid>
      )}

      <ConfirmFormModal
        isOpen={openConfirmBox}
        handleClose={() => {
          handleConfirmation();
        }}
        confirmCondition={false}
        header={confirmationMgs.header}
        body={
          <p style={{ padding: "0px 20px 10px 20px", fontSize: "14px" }}>
            {confirmationMgs.text}
          </p>
        }
        size="xs"
        successHandler={deleteDraw}
        primaryBtnName="Delete"
        disableBackdropClick
        footerStyles={{
          marginTop: "0px",
          padding: "0px 20px 20px 20px"
        }}
        headerStyles={{
          paddingBottom: "10px",
          borderBottom: "1px solid #979797"
        }}
      />
      <SnackBarMessage
        open={openSnackBar}
        verticalPlacement={snackBarDetails.verticalPlacement}
        horizontalPlacement={snackBarDetails.horizontalPlacement}
        autoHideDuration={snackBarDetails.autoHideDuration}
        handleClose={() => setOpenSnackBar(false)}
        messageType={snackBarMsg.messageType}
        message={snackBarMsg.message}
      />
    </>
  );
};